import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import FAQSection from './components/FAQSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <RankingSection />
        <TopicsSection />
        <AboutSection />
        <ContactSection />
        <CommentsSection />
        <FAQSection />
        <UpdatesSection />
        <AppSection />
        <IndexSection />
        <FeaturesSection />
        <CarouselSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}